import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Transition, Icon, Checkbox, Popup, Dimmer, Loader } from "semantic-ui-react";
import { toggleExibirVotacao } from "../../../actions/votacao";
import moment from 'moment';
import 'moment/locale/pt-br';
import BotaoEditar from '../../layouts/BotaoEditar';
moment.locale('pt-BR');

export const statusVotacao = votacao => {
  if (votacao.votacaoFinalizada) return { chave: 'finalizada', texto: 'Finalizada' };
  if (votacao.votacaoIniciada) return { chave: 'andamento', texto: 'Em andamento' };
  return { chave: 'bloqueada', texto: 'Bloqueada' };
};

export default function Votacao({ votacao, atualizarLista }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const status = statusVotacao(votacao);
  const pautas = (votacao.perguntas || []).length;
  const mesmoDia = votacao.dataInicioReuniao === votacao.dataFinalReuniao;

  async function toggleVotacao() {
    setLoading(true);
    await dispatch(toggleExibirVotacao(votacao._id));
    await atualizarLista();
    setLoading(false);
  }

  return (
    <Transition duration={500} animation="fade up" transitionOnMount={true}>
      <article className="va-vot">
        <Dimmer active={loading} inverted>
          <Loader />
        </Dimmer>
        <header className="va-vot-topo">
          <span className={`va-recente-status ${status.chave === 'andamento' ? 'andamento' : status.chave}`}>{status.texto}</span>
          <span className="va-vot-pautas">{pautas} pauta{pautas !== 1 && 's'}</span>
        </header>
        <h3 className="va-vot-titulo">{votacao.titulo}</h3>
        <small className="va-vot-criada">Criada {moment(votacao.createdAt).fromNow()}</small>

        <ul className="va-vot-info">
          <li><Icon name="calendar alternate outline" />{mesmoDia ? votacao.dataInicioReuniao : `${votacao.dataInicioReuniao} a ${votacao.dataFinalReuniao}`}</li>
          <li><Icon name="clock outline" />{votacao.horarioReuniao || '00:00'} às {votacao.horarioFinalReuniao || '23:59'}</li>
          {votacao.local && <li><Icon name="map marker alternate" /><span title={votacao.local}>{votacao.local}</span></li>}
          {votacao.urlTransmissao && (
            <li><Icon name="tv" /><a href={votacao.urlTransmissao} target="_blank" rel="noopener noreferrer">Transmissão online</a></li>
          )}
        </ul>

        <footer className="va-vot-rodape">
          <Popup
            content="Mostra ou oculta esta votação no aplicativo dos condôminos."
            position="top center"
            trigger={
              <label className="va-vot-exibir">
                <Checkbox toggle name="ativo" onChange={() => toggleVotacao()} checked={votacao.exibirNoApp} />
                <span>{votacao.exibirNoApp ? 'Visível no app' : 'Oculta no app'}</span>
              </label>
            }
          />
          <BotaoEditar to={`/condominios/${votacao.condominio}/votacoes/editar/${votacao._id}/sobre`} dica="Editar votação, pautas e relatórios" rotulo={`Editar ${votacao.titulo}`} />
        </footer>
      </article>
    </Transition>
  );
}
